export default __webpack_public_path__ + "static/media/mec-3.e33f3202.png";